<template>
  <div class="car_rent_signature_1">
    <div class="car_rent_signature_nav">
      <navbar
        title="合同签署"
        :lefticon="lefticon"
        :lefticonheight="2.4"
        :lefticonwidth="2.4"
        :fontweight="700"
        :fontsize="'1.7rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="car_rent_signature" :style="signatureStyle">
      <canvas ref="signcanvas" class="canvas"></canvas>
      <div class="bottom">
        <btn
          :btntext="'重写'"
          :btnwidth="'16.9rem'"
          :height="'4.9rem'"
          :bgcolor="'#fff'"
          :borderradius="'0.6rem'"
          :btncolor="'#333'"
          :fontsize="'1.7rem'"
          :fontweight="700"
          :btnborder="'solid 0.05rem #ccc'"
          :btnmargin="'0 1.2rem 0 0'"
          @btnClick="clearCanvas"
        />
        <btn
          :btntext="'签署完成'"
          :btnwidth="'17rem'"
          :height="'5rem'"
          :bgcolor="'linear-gradient(to right, #49A6FF, #236DFE)'"
          :borderradius="'0.6rem'"
          :btncolor="'#fff'"
          :fontsize="'1.7rem'"
          :fontweight="700"
          @btnClick="confirm"
        />
      </div>
    </div>
    <div class="loading" v-if="isLoading">
      <img src="../../assets/accountAgent/common/loading.gif" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import navbar from "../purchaseSupplier/components/nav-bar.vue";
import btn from "../purchaseSupplier/components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/carRent/reback@2x.png"),
      canvas: {},
      ctx: {},
      isConfirm: false,
      signatureStyle: {
        width: "calc(100% - 88px)",
        height: "100%",
        transformOrigin: "left top",
        transform: "",
      },
      canvasStyle: {
        width: "",
        height: "",
      },
      isLoading: false,
    };
  },
  created() {},
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  mounted() {
    // 横屏效果 设置宽等于高，高等于宽
    this.signatureStyle.width = document.body.clientHeight - 88 + "px"; //375
    this.signatureStyle.height = document.body.clientWidth + "px"; //667
    // 因为设置了transformOrigin: 'left top'，所以直接向右移动屏幕宽度 + 旋转90° 刚好形成横屏效果
    this.signatureStyle.transform = `translate(${document.body.clientWidth}px) rotate(90deg)`;

    this.canvasStyle = {
      width: document.body.clientHeight - 88 + "px",
      // 底部85
      height: document.body.clientWidth - 85 + "px",
    };
    this.initCanvas();
  },
  methods: {
    initCanvas() {
      const canvas = this.$refs.signcanvas;
      this.canvas = canvas;

      const ctx = this.canvas.getContext("2d");
      this.ctx = ctx;

      const height = this.canvasStyle.height.replace("px", "");
      const width = this.canvasStyle.width.replace("px", "");

      canvas.height = height;
      canvas.width = width;

      // 根据设备像素比优化canvas绘图
      const devicePixelRatio = window.devicePixelRatio;
      if (devicePixelRatio) {
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        canvas.height = height * devicePixelRatio;
        canvas.width = width * devicePixelRatio;
        ctx.scale(devicePixelRatio, devicePixelRatio);
      } else {
        canvas.width = width;
        canvas.height = height;
      }

      // 线宽
      ctx.lineWidth = 3;
      // 线条颜色
      ctx.strokeStyle = "#000000";
      // 线的两端样式 round圆角
      ctx.lineCap = "round";
      // 线的交叉处样式 round圆角
      ctx.lineJoin = "round";

      const { left, top } = this.canvas.getBoundingClientRect();

      const touchstartFunc = (e) => {
        e.preventDefault();
        // console.log(left, top);
        // const x = e.touches[0].clientX - left
        // const y = e.touches[0].clientY - top
        // 由于页面旋转过，所以需要将 clientX 和 canvas坐标系 一一对应，clientY同理
        const x = e.touches[0].clientY - top;
        const y = document.body.clientWidth - e.touches[0].clientX;
        this.ctx.beginPath();
        this.ctx.moveTo(x, y);
      };
      const touchmoveFunc = (e) => {
        e.preventDefault();
        const x = e.touches[0].clientY - top;
        const y = document.body.clientWidth - e.touches[0].clientX;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();
      };
      this.canvas.addEventListener("touchstart", touchstartFunc, false);
      this.canvas.addEventListener("touchmove", touchmoveFunc, false);
    },
    clearCanvas() {
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    },
    goBack() {
      this.$router.go(-1);
    },
    dataURLtoFile(dataURL, fileName, fileType) {
      var arr = dataURL.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: fileType || "image/png" });
    },
    async confirm() {
      this.isLoading = true;
      try {
        let img = this.canvas.toDataURL("image/png");

        const token = await this.$api.post(
          "contract/member/file/update/token",
          { type: "seal" }
        );
        const key = `${token.file_path}.png`;

        const img_file = this.dataURLtoFile(img, key, "image/png");
        let formData = new FormData();
        formData.append("token", token.token);
        formData.append("file", img_file);
        formData.append("key", key);

        const res = await axios.post("https://up-z0.qiniup.com", formData);
        this.isConfirm = true;
        this.img_file = img;
        this.img_name = res.key;
        this.$api
          .post("/onorder/member/car/autograph", {
            id: this.$route.query.contract_id,
            seal: this.img_name,
          })
          .then((res) => {
            this.isLoading = false;
            sessionStorage.setItem("contractSigned", true);
            if (sessionStorage.getItem("pushEnter")) {
              this.params("", "", "goBack");
            } else if (sessionStorage.getItem("signedBack")) {
              this.$router.go(-Number(sessionStorage.getItem("signedBack")));
            } else {
              sessionStorage.setItem("orderBack", true);
              this.$router.replace("/carRent/orderList");
            }
          })
          .catch((err) => {
            this.isLoading = false;
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
          });
      } catch (error) {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>

<style lang="less">
.car_rent_signature_1 {
  height: 100%;
  padding-top: 8.8rem;
  box-sizing: border-box;

  .car_rent_signature_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .car_rent_signature {
    background-color: #f8f8f8;

    .canvas {
      margin: 0;
      border-bottom: solid 0.1rem #d8d8d8;
    }
    .bottom {
      height: 8.5rem;
      padding-top: 1.5rem;
      box-sizing: border-box;
      text-align: center;
    }
  }

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }
}
</style>
